import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Информация о заказе ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Дата создания заказа ")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "w-full h-px bg-black/3 my-2" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Статус заказа ")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "w-full h-px bg-black/3 my-2" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Сумма заказа ")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "w-full h-px bg-black/3 my-2" }, null, -1)
const _hoisted_8 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Номер ячейки ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" ПИН-код ")
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "w-full h-px bg-black/3 my-2" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Детализация заказа ")
const _hoisted_14 = { class: "w-4 opacity-60 text-xs self-center" }
const _hoisted_15 = { class: "min-w-0" }
const _hoisted_16 = { class: "first-letter:uppercase leading-tight truncate" }
const _hoisted_17 = { class: "font-medium" }
const _hoisted_18 = { class: "text-xs opacity-60 mr-1" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Отменить заказ ")

import { computed, PropType } from "vue";
import { useVModel } from "@vueuse/core";

import { IRequest } from "@/types/request";
import { useAsync } from "@/use/useAsync";
import { useRequests } from "@/use/useRequests";
import { formatDate, formatCurrency } from "@/utils";

import UiBtn from "@/plugins/ui/components/button/UiBtn.vue";
import UiCell from "@/plugins/ui/components/cell/UiCell.vue";
import UiSubhead from "@/plugins/ui/components/typography/UiSubhead.vue";
import UiText from "@/plugins/ui/components/typography/UiText.vue";

import UiModalPage from "@/components/ui/UiModalPage.vue";
import UiModalPageHeader from "@/components/ui/UiModalPageHeader.vue";
import UiModalPageHeaderClose from "@/components/ui/UiModalPageHeaderClose.vue";
import { useMessage } from "@/plugins/message";
import axios from "axios";


export default /*#__PURE__*/_defineComponent({
  __name: 'RequestPreviewModal',
  props: {
  modelValue: { type: Boolean, default: false },
  request: { type: Object as PropType<IRequest>, required: true },
},
  setup(__props) {

const props = __props



const message = useMessage();

const { deleteRequest } = useRequests();

const showModal = useVModel(props, "modelValue");

const status = computed(() => {
  switch (props.request.status) {
    case "accept":
      return "Готов к выдаче";
    case "wait":
      return "Принят в обработку";
    case "success":
      return "Завершен";
    case "eject":
      return "Изъят";
    case "reject":
      return "Отменен в столовой";
    case "cancel":
      return "Отменен пользователем";
    default:
      return "Без типа";
  }
});

const handleDeleteRequest = useAsync(async () => {
  try {
    await deleteRequest(props.request.id);
    // eslint-disable-next-line vue/no-mutating-props
    props.request.status = "cancel";
    showModal.value = false;
  } catch (e) {
    if (axios.isAxiosError(e)) {
      message({ text: e.response?.data.errors.message, type: "danger" });
    }
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UiModalPage, {
    modelValue: _unref(showModal),
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(showModal) ? (showModal).value = $event : null))
  }, {
    header: _withCtx(() => [
      _createVNode(UiModalPageHeader, null, {
        before: _withCtx(() => [
          _createVNode(UiModalPageHeaderClose, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showModal.value = false))
          })
        ]),
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(UiSubhead, {
        weight: "semibold",
        style: {"margin-bottom":"4px"}
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _createVNode(UiText, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(formatDate)(__props.request.operation.date)), 1)
        ]),
        _: 1
      }),
      _hoisted_3,
      _createVNode(UiSubhead, {
        weight: "semibold",
        style: {"margin-bottom":"4px"}
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }),
      _createVNode(UiText, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(status)), 1)
        ]),
        _: 1
      }),
      _hoisted_5,
      _createVNode(UiSubhead, {
        weight: "semibold",
        style: {"margin-bottom":"4px"}
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }),
      _createVNode(UiText, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(formatCurrency)(__props.request.operation.sum / 100)), 1)
        ]),
        _: 1
      }),
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", null, [
          _createVNode(UiSubhead, {
            weight: "semibold",
            style: {"margin-bottom":"4px"}
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }),
          _createVNode(UiText, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.request.position.number), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", null, [
          _createVNode(UiSubhead, {
            weight: "semibold",
            style: {"margin-bottom":"4px"}
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }),
          _createVNode(UiText, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.request.pin), 1)
            ]),
            _: 1
          })
        ])
      ]),
      (__props.request.operation.items.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(UiSubhead, {
              weight: "semibold",
              style: {"margin-bottom":"4px"}
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.request.operation.items, (item, index) => {
              return (_openBlock(), _createBlock(UiCell, {
                key: item.name
              }, {
                left: _withCtx(() => [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(index + 1) + ". ", 1)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("p", _hoisted_16, _toDisplayString(item.name), 1),
                    _createElementVNode("p", _hoisted_17, [
                      _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(formatCurrency)(item.price / 100)) + " x " + _toDisplayString(item.count) + " = ", 1),
                      _createTextVNode(" " + _toDisplayString(_unref(formatCurrency)((item.count * item.price) / 100)), 1)
                    ])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (__props.request.status === 'wait')
        ? (_openBlock(), _createBlock(UiBtn, {
            key: 1,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(handleDeleteRequest).execute())),
            loading: _unref(handleDeleteRequest).isPending.value,
            disabled: _unref(handleDeleteRequest).isPending.value,
            variant: "secondary",
            block: "",
            style: {"margin-top":"24px"}
          }, {
            default: _withCtx(() => [
              _hoisted_19
            ]),
            _: 1
          }, 8, ["loading", "disabled"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})